export default __webpack_public_path__ + "assets/images/3606696c066b676264aa6645a2843ca7.svg";